// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { transformResponseHandler } from "../../Utils/transformResponse";
// import ApiRoutes from "../../Utils/ApiRoutes";

// export const CommonApis = createApi({
//   reducerPath: "CommonApis",
//   baseQuery: fetchBaseQuery({
//     baseUrl: process.env.REACT_APP_API_ROUTE,
//     prepareHeaders: (headers, { getState }) => {
//       const token = getState().usertoken?.token;
//       if (token) {
//         headers.set("authorization", `${token}`);
//       }
//       return headers;
//     },
//   }),
//   endpoints: (builder) => ({
//     getRrb: builder.query({
//       query: (postId) => ({
//         url: `${ApiRoutes.getRrb}`,
//         method: "GET",
//       }),
//       transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
//       transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
//     }),
//      getStates: builder.query({
//         query: ({ rrbId }) => ({
//           url: `${ApiRoutes.getStates}/${rrbId}`,
//           method: "GET",
//         }),
//         transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
//         transformErrorResponse: (error,meta) => transformResponseHandler(error, meta,true),
//       }),
//     getCity: builder.query({
//         query: ({ rrbId, stateId }) => ({
//           url: `${ApiRoutes.getCity}/${rrbId}/${stateId}`,
//           method: "GET",
        
//         }),
       
//         transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
//         transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
//       }),
//       getCentres: builder.query({
//         query: ({ cityId }) => ({
//           url: `${ApiRoutes.getCentres}/${cityId}`,
//           method: "GET",
//         }),
//         transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
//         transformErrorResponse: (error,meta) => transformResponseHandler(error,meta, true),
//       }),
     
//   }),
// });

// export const {useGetRrbQuery,useGetCityQuery,useGetCentresQuery,useGetStatesQuery } = CommonApis;


import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformResponseHandler } from "../../Utils/transformResponse";
import ApiRoutes from "../../Utils/ApiRoutes";
import { apiEncrypted } from "../../Utils/function";

export const CommonApis = createApi({
  reducerPath: "CommonApis",
  baseQuery: async (args, api, extraOptions) => {
    const result = apiEncrypted(args, api, extraOptions)
    return result;   
  },
  endpoints: (builder) => ({
    getRrb: builder.query({
      query: (postId) => ({
        url: `${ApiRoutes.getRrb}`,
        method: "GET",
      }),
      transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
    getStates: builder.query({
      query: ({ rrbId }) => ({
        url: `${ApiRoutes.getStates}`,
        method: "GET",
        params:{
          rrb_id:rrbId ?? "",
      } 
      }),
      transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
      transformErrorResponse: (error,meta) => transformResponseHandler(error, meta,true),
    }),
    getCity: builder.query({
        query: ({ rrbId, stateId }) => ({
          url: `${ApiRoutes.getCity}`,
          method: "GET",
          params:{
            rrb_id:rrbId ?? "",
            state_id: stateId ?? "",  
        } 
        }),   
        transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
        transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
      }),
      getCentres: builder.query({
        query: ({ cityId }) => ({
          url: `${ApiRoutes.getCentres}`,
          method: "GET",
          params:{     
            city_id: cityId ?? "",      
        } 
        }),
      
        transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
        transformErrorResponse: (error,meta) => transformResponseHandler(error,meta, true),
      }),
     
  }),
});

export const {useGetRrbQuery,useGetCityQuery,useGetCentresQuery,useGetStatesQuery } = CommonApis;
